import{VALID_TAGS as t}from"./constants.js";const n=n=>"tag"===n.type&&t.includes(n.name);export{n as isValidNode};
//# sourceMappingURL=isValidNode.js.map
